// @tenorlab/nuxt-dashboard-pro
// file: app/utils/env.utils.ts
export function getWidgetsManifestUrl(): string {
  const config = useRuntimeConfig() // nuxt
  const url = config.public.widgetsManifestUrl // see nuxt.config.ts section runtimeConfig (env var name is NUXT_PUBLIC_WIDGETS_MANIFEST_URL)

  // Useful for debugging during the fix
  if (!url) {
    console.warn('widgetsManifestUrl is not defined')
  }

  return (url || '').trim()
}

export function getAppConfigKey() {
  // if our env NUXT_PUBLIC_APP_CONFIG variable is set, get its value
  // (see nuxt.config.ts section runtimeConfig)
  // @ts-ignore
  if (process.env && process.env.NODE_ENV) {
    // @ts-ignore
    let env = process.env.NODE_ENV.trim().toLowerCase()
    if (env === 'development') {
      env = 'dev'
    }
    return env
  }

  // Note: Vite uses import.meta.env (reference: https://vitejs.dev/guide/env-and-mode.html)
  // NUXT uses NUXT_PUBLIC...
  const config = useRuntimeConfig()
  const result = config.public.appConfigKey
  return result
}
